// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"Graph_graphContainer__1Uj2-","title":"Graph_title__12Y_R","graph":"Graph_graph__3l3QX"};